var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Resumen del Documento",
          breadcrumbs: _vm.breadcrumbs,
          breadcrumbsItemDinamic: {
            loading: _vm.loadingDetail,
            text: (_vm.activeDocument || {}).name,
          },
          dense: true,
          hiddenTab: true,
          addPadding: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-2",
                    attrs: { outlined: "" },
                    on: { click: _vm.retrieve },
                  },
                  [
                    _c("v-img", {
                      attrs: {
                        contain: "",
                        src: require(`@/assets/icon-update${
                          _vm.$vuetify.theme.dark ? "-dark" : ""
                        }.svg`),
                      },
                    }),
                  ],
                  1
                ),
                ["FAI", "SNT"].includes(_vm.instance.status)
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "mr-2",
                        attrs: { outlined: "" },
                        on: {
                          click: function ($event) {
                            _vm.dialogReprocessSummarie = true
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-file-refresh"),
                        ]),
                        _vm._v("Re-procesar el resumen"),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.$vuetify.breakpoint.width <= 1920
                  ? _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-click": "",
                          "close-on-content-click": "",
                          "offset-y": "",
                          left: "",
                          "nudge-bottom": 10,
                          transition: "slide-y-transition",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        { attrs: { outlined: "" } },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v("mdi-plus-box "),
                                      ]),
                                      _vm._v("Opciones"),
                                      _c(
                                        "v-icon",
                                        { attrs: { size: "18", right: "" } },
                                        [_vm._v("mdi-chevron-down")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          135455893
                        ),
                      },
                      [
                        _c(
                          "v-list",
                          { staticClass: "pa-0" },
                          [
                            _c(
                              "v-list-item",
                              {
                                staticClass: "px-3",
                                attrs: { ripple: false },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadFile2(
                                      "summaries",
                                      _vm.nameXML
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-title",
                                  { staticClass: "body-1 grey-500--text" },
                                  [_vm._v("Descargar documento")]
                                ),
                              ],
                              1
                            ),
                            ["APR", "OBS"].includes(_vm.instance.status)
                              ? _c(
                                  "v-list-item",
                                  {
                                    staticClass: "px-3",
                                    attrs: { ripple: false },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadFile2(
                                          "summaries",
                                          `${_vm.instance.type}_${_vm.instance.number}`,
                                          null,
                                          "voucher"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-1 grey-500--text" },
                                      [_vm._v("Descargar CDR")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "px-0", staticStyle: { "z-index": "0" } },
        [
          _vm.loadingDetail
            ? _c("skeleton-detail")
            : _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "mr-6",
                    staticStyle: { "min-width": "400px" },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { position: "fixed!important" } },
                      [
                        _c(
                          "v-img",
                          {
                            attrs: {
                              contain: "",
                              width: 400,
                              height: 110,
                              src: require(`@/assets/backgrounds/background-document-detail.svg`),
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "px-4 pt-4 subtitle-2 white--text font-weight-bold d-inline-block text-truncate",
                                staticStyle: { "max-width": "300px" },
                              },
                              [_vm._v(" " + _vm._s(_vm.nameXML) + " ")]
                            ),
                            _c(
                              "v-row",
                              {
                                staticClass: "ml-2 mt-3",
                                attrs: { align: "end", "no-gutters": "" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "py-0 px-2",
                                    attrs: { cols: "5" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Fecha")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("date")(
                                                  _vm.instance.date
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-0 mt-4",
                            staticStyle: { position: "fixed!important" },
                            attrs: {
                              width: "400",
                              transition: "slide-y-transition",
                              "min-height": "calc(100% - 278px)",
                              flat: "",
                            },
                          },
                          [
                            _c(
                              "v-toolbar",
                              {
                                attrs: {
                                  color: "transparent",
                                  flat: "",
                                  height: "46",
                                },
                              },
                              [
                                _c(
                                  "v-toolbar-title",
                                  {
                                    staticClass:
                                      "px-5 subtitle-2 grey-500--text font-weight-bold",
                                  },
                                  [_vm._v("Resumen del documento")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-card-text",
                              {
                                staticClass: "overflow-y-auto pa-0",
                                style:
                                  _vm.$vuetify.breakpoint.height <= 700
                                    ? "max-height: calc(100vh - 353px)"
                                    : "max-height: calc(100vh - 300px)",
                              },
                              [
                                _c("v-divider"),
                                _c(
                                  "div",
                                  { staticClass: "py-4 px-5" },
                                  [
                                    _c(
                                      "v-list",
                                      {
                                        staticClass:
                                          "v-list-form-main transparent pa-0",
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("generals.RUT"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.instance || {}).tax_id
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("Tipo de documento")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.activeDocument?.name ??
                                                      ""
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.instance.status !== "draft"
                                          ? _c(
                                              "v-list-item",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "grey-500--text subtitle-2",
                                                  },
                                                  [_vm._v("Resumen ID")]
                                                ),
                                                _c(
                                                  "v-list-item-subtitle",
                                                  { staticClass: "body-1" },
                                                  [_vm._v(_vm._s(_vm.nameXML))]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("ID")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      color: "grey-background",
                                                      right: "",
                                                      transition:
                                                        "scale-transition",
                                                      "max-width": "300",
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "grey-300--text",
                                                                  attrs: {
                                                                    text: "",
                                                                    ripple: false,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.toClipboard(
                                                                          _vm
                                                                            .instance
                                                                            .id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.instance
                                                                      .id
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-block px-3 py-2",
                                                      },
                                                      [_vm._v("Copiar")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("Fecha de ref.")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("date")(
                                                      _vm.instance
                                                        .reference_date
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("Creado el")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("dateTimeSecond")(
                                                      _vm.instance.created
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "pb-5",
                    staticStyle: { flex: "1", "min-width": "180px" },
                  },
                  [
                    _c(
                      "v-card",
                      { staticClass: "mt-1", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "46",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-5 subtitle-2 grey-700--text font-weight-semibold",
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      align: "center",
                                      "no-gutters": "",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "ml-n1 mr-2",
                                      attrs: {
                                        src: require(`@/assets/ax/sunat--icon.svg`),
                                      },
                                    }),
                                    _vm._v(" Sunat "),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _c("v-card-text", { staticClass: "pa-0" }, [
                          _c(
                            "div",
                            { staticClass: "pt-4 px-5 pb-3" },
                            [
                              _c(
                                "v-list",
                                {
                                  staticClass:
                                    "v-list-form-status transparent pa-0",
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "grey-500--text subtitle-2 font-weight-bold",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-3",
                                              attrs: {
                                                size: "20",
                                                left: "",
                                                color: "grey-900",
                                              },
                                            },
                                            [_vm._v("mdi-clipboard")]
                                          ),
                                          _vm._v("Estado"),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-subtitle",
                                        { staticClass: "body-1" },
                                        [
                                          !_vm.instance.status ||
                                          _vm.instance?.status === "IMP"
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    loading:
                                                      _vm.taxAgencyLoader,
                                                    text: "",
                                                    color: "grey-900",
                                                    ripple: false,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.taxAgencyService(
                                                        "documents",
                                                        "documents",
                                                        "irs_status"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Actualizar estado")]
                                              )
                                            : _vm.instance?.status === "PDR"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text--disabled d-block",
                                                },
                                                [_vm._v("Sin estado")]
                                              )
                                            : _c("chip-status", {
                                                attrs: {
                                                  status: _vm.instance?.status,
                                                  detail:
                                                    _vm.instance
                                                      .agency_status ||
                                                    _vm.instance
                                                      .agency_status_info
                                                      ? `${_vm.instance.agency_status} <br> ${_vm.instance.agency_status_info}`
                                                      : null,
                                                  showDetail: true,
                                                  isTooltip: false,
                                                  type: "summaries",
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  (_vm.instance || {}).agency_status
                                    ? _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "grey-500--text subtitle-2 font-weight-bold",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    size: "20",
                                                    left: "",
                                                    color: "grey-900",
                                                  },
                                                },
                                                [_vm._v("mdi-clipboard-search")]
                                              ),
                                              _vm._v("Detalle del estado"),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 align-self-start mt-2",
                                              staticStyle: {
                                                "white-space":
                                                  "normal !important",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.instance.agency_status
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  (_vm.instance || {}).agency_status_info
                                    ? _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c("v-list-item-title", {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          }),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 align-self-start",
                                              staticStyle: {
                                                "white-space":
                                                  "normal !important",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-sheet",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "grey-300--text",
                                                    staticStyle: {
                                                      "justify-content": "left",
                                                    },
                                                  },
                                                  _vm.instance
                                                    .agency_status_info
                                                    .length >= 256
                                                    ? _vm.on
                                                    : false
                                                ),
                                                [
                                                  _c("span", {}, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.instance.agency_status_info?.slice(
                                                          0,
                                                          256
                                                        )
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.instance
                                                            .agency_status_info
                                                            .length >= 256
                                                            ? "..."
                                                            : ""
                                                        )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  (_vm.instance || {})
                                    ?.agency_status_detail_list
                                    ? _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c("v-list-item-title", {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          }),
                                          (_vm.instance || {})
                                            .agency_status_detail_list
                                            ? _c(
                                                "v-list-item-subtitle",
                                                {
                                                  staticClass:
                                                    "body-1 align-self-start mt-2",
                                                  staticStyle: {
                                                    "white-space":
                                                      "normal !important",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.instance?.agency_status_detail_list?.slice(
                                                      0,
                                                      2
                                                    ),
                                                    function (detail, i) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: i,
                                                          staticClass:
                                                            "d-block mb-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              detail?.slice(
                                                                0,
                                                                156
                                                              ) &&
                                                                i ===
                                                                  _vm.instance.agency_status_detail_list?.slice(
                                                                    0,
                                                                    2
                                                                  ).length -
                                                                    1 &&
                                                                detail.length >=
                                                                  156
                                                                ? `${detail}...`
                                                                : detail
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm.instance
                                                    .agency_status_detail_list
                                                    .length >= 2
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            text: "",
                                                            color: "grey-900",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.dialogSunat = true
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Ver más")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.$store.state.auth.account.country !== "PE"
                                    ? _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "grey-500--text subtitle-2",
                                            },
                                            [_vm._v("Track ID")]
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "body-1" },
                                            [
                                              (
                                                (_vm.instance || {}).status ||
                                                {}
                                              ).irs_id
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        color:
                                                          "grey-background",
                                                        right: "",
                                                        transition:
                                                          "scale-transition",
                                                        "max-width": "300",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "grey-300--text",
                                                                      staticStyle:
                                                                        {
                                                                          "justify-content":
                                                                            "left",
                                                                        },
                                                                      attrs: {
                                                                        text: "",
                                                                        ripple: false,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            _vm.toClipboard(
                                                                              (
                                                                                (
                                                                                  _vm.instance ||
                                                                                  {}
                                                                                )
                                                                                  .status ||
                                                                                {}
                                                                              )
                                                                                .irs_id
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        (
                                                                          (
                                                                            _vm.instance ||
                                                                            {}
                                                                          )
                                                                            .status ||
                                                                          {}
                                                                        ).irs_id
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        3006885842
                                                      ),
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-block px-3 py-2",
                                                        },
                                                        [_vm._v("Copiar")]
                                                      ),
                                                    ]
                                                  )
                                                : (
                                                    (_vm.instance || {})
                                                      .status || {}
                                                  ).id !== "PDR"
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            loading:
                                                              _vm.taxAgencyLoader,
                                                            text: "",
                                                            color: "grey-900",
                                                            ripple: false,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.taxAgencyService(
                                                                "documents",
                                                                "documents",
                                                                "irs_send"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Enviar a la agencia fiscal"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "v-card",
                      { staticClass: "mt-5 d-none", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "46",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-5 subtitle-2 grey-700--text font-weight-semibold",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      size: "18",
                                      left: "",
                                      color: "grey-700",
                                    },
                                  },
                                  [_vm._v("mdi-timeline-clock")]
                                ),
                                _vm._v("Eventos"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.eventLoading
                          ? _c("v-skeleton-loader", {
                              staticClass: "mb-2 panel px-1 rounded-md",
                              attrs: {
                                transition: "fade-transition",
                                type: "list",
                              },
                            })
                          : (_vm.eventsList || []).length
                          ? [
                              _c("v-divider"),
                              _c(
                                "v-card-text",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass:
                                        "transparent px-0 py-2 dense",
                                    },
                                    [
                                      _vm._l(_vm.events, function (d, i) {
                                        return _c(
                                          "div",
                                          { key: i },
                                          [
                                            _c(
                                              "v-list-item",
                                              {
                                                key: i,
                                                staticClass: "px-5 py-0",
                                              },
                                              [
                                                _c(
                                                  "v-list-item-icon",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "grey-900",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentEvent(
                                                              d.event_type
                                                            ).icon
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  { staticClass: "ml-n5" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-block grey-700--text body-1",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "font-weight-bold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.currentEvent(
                                                                  d.event_type
                                                                ).summary
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-block body-2 grey-300--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateTimeSecond"
                                                            )(d.created)
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            i !== _vm.eventsList.length - 1
                                              ? _c(
                                                  "v-sheet",
                                                  {
                                                    staticClass:
                                                      "text-left ml-8 mt-n4 mb-n2",
                                                    attrs: { height: "18" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          left: "30px",
                                                        },
                                                        attrs: {
                                                          size: "3",
                                                          color: "placeholder",
                                                        },
                                                      },
                                                      [_vm._v("mdi-circle")]
                                                    ),
                                                    _c("v-divider", {
                                                      staticClass: "my-0",
                                                      attrs: { vertical: "" },
                                                    }),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mb-n1",
                                                        staticStyle: {
                                                          left: "-1px",
                                                          top: "7px",
                                                        },
                                                        attrs: {
                                                          size: "3",
                                                          color: "placeholder",
                                                        },
                                                      },
                                                      [_vm._v("mdi-circle")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }),
                                      _vm.eventsList.length > 3
                                        ? [
                                            _c("v-divider", {
                                              staticClass: "mt-4",
                                            }),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "mt-1 mb-n1 mx-5",
                                                attrs: {
                                                  color: "grey-900",
                                                  text: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.showMoreEvents =
                                                      !_vm.showMoreEvents
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      !_vm.showMoreEvents
                                                        ? "Ver todos los eventos"
                                                        : "Ver menos eventos"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "v-card",
                      { staticClass: "mt-5", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "60",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "d-flex align-center pl-5 subtitle-2 grey-700--text font-weight-semibold",
                                staticStyle: { "min-width": "230px" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      size: "18",
                                      left: "",
                                      color: "grey-700",
                                    },
                                  },
                                  [_vm._v("mdi-file-document-multiple")]
                                ),
                                _vm._v(" Documentos referenciados "),
                              ],
                              1
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-toolbar-items",
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0",
                                    attrs: {
                                      align: "center",
                                      justify: "end",
                                      "no-gutters": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            prefix: "Serie",
                                            outlined: "",
                                            required: "",
                                            "single-line": "",
                                            dense: "",
                                            maxlength: "60",
                                            "persistent-hint": "",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: _vm.searchReferences.series,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.searchReferences,
                                                "series",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchReferences.series",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mx-3",
                                        attrs: { cols: "4" },
                                      },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            prefix: "Correlativo",
                                            outlined: "",
                                            required: "",
                                            "single-line": "",
                                            dense: "",
                                            maxlength: "60",
                                            "persistent-hint": "",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: _vm.searchReferences.serial,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.searchReferences,
                                                "serial",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchReferences.serial",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pr-14",
                                        attrs: { cols: "1" },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              text: "",
                                              color: "grey-900",
                                            },
                                            on: {
                                              click: _vm.filterByReferences,
                                            },
                                          },
                                          [_vm._v("Filtrar")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _c(
                          "v-card-text",
                          { staticClass: "pa-0" },
                          [
                            _c("v-data-table", {
                              staticClass: "table-not-rounded",
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                headers: _vm.referencesHeaders,
                                items: _vm.currentReferencesFiltered,
                                "hide-default-header": "",
                                "disable-sort": "",
                                "hide-default-footer": "",
                                "no-data-text": "No se encontraron documentos",
                                "items-per-page": 10,
                              },
                              on: {
                                "click:row": (currentReferencesFiltered) => {
                                  currentReferencesFiltered.document_id
                                    ?.length > 0
                                    ? _vm.goTo(
                                        currentReferencesFiltered.document_id
                                      )
                                    : ""
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function ({ props: { headers } }) {
                                      return [
                                        _c("VTableHeaders", {
                                          attrs: { headers: headers },
                                          on: {
                                            sort: function ($event) {
                                              return _vm.sorting($event)
                                            },
                                          },
                                        }),
                                        _c("v-divider", {
                                          staticStyle: {
                                            "min-width": "100%",
                                            position: "absolute",
                                            "margin-top": "-6px",
                                            "margin-left": "-5px",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.type`,
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", { staticClass: "body-2" }, [
                                          _vm._v(
                                            _vm._s(_vm.currentType(item.type))
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.number`,
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", { staticClass: "body-2" }, [
                                          _vm._v(_vm._s(item.number)),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.date`,
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", { staticClass: "body-2" }, [
                                          _vm._v(
                                            _vm._s(_vm._f("date")(item.date))
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.document_id`,
                                    fn: function ({ item }) {
                                      return [
                                        item.document_id?.length > 0
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  color: "grey-background",
                                                  left: "",
                                                  transition:
                                                    "scale-transition",
                                                  "max-width": 280,
                                                  "open-on-hover": "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({ on }) {
                                                        return [
                                                          _c(
                                                            "v-chip",
                                                            _vm._g(
                                                              {
                                                                staticClass:
                                                                  "px-2",
                                                                attrs: {
                                                                  color:
                                                                    "grey-200",
                                                                  small: "",
                                                                  label: "",
                                                                },
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-700",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-file-document-remove"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block px-3 py-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Documento procesado"
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "790",
            persistent: "",
            scrollable: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogSunat,
            callback: function ($$v) {
              _vm.dialogSunat = $$v
            },
            expression: "dialogSunat",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Detalle del estado")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogSunat = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 pt-6 pb-0" },
                _vm._l(
                  _vm.instance.agency_status_detail_list,
                  function (detail, i) {
                    return _c(
                      "div",
                      { key: i },
                      [
                        _c("span", { staticClass: "d-block mb-8" }, [
                          _vm._v(_vm._s(detail)),
                        ]),
                        i !== _vm.instance.agency_status_detail_list.length - 1
                          ? _c(
                              "v-sheet",
                              {
                                staticClass: "text-left ml-1 mt-n8 mb-3",
                                attrs: { height: "10" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mt-1",
                                    staticStyle: {
                                      position: "absolute",
                                      left: "22.5px",
                                    },
                                    attrs: { size: "3", color: "placeholder" },
                                  },
                                  [_vm._v("mdi-circle")]
                                ),
                                _c("v-divider", {
                                  staticClass: "my-0",
                                  attrs: { vertical: "" },
                                }),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mb-n1",
                                    staticStyle: { left: "-0.4px", top: "7px" },
                                    attrs: { size: "3", color: "placeholder" },
                                  },
                                  [_vm._v("mdi-circle")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900", ripple: false },
                      on: {
                        click: function ($event) {
                          _vm.dialogSunat = false
                        },
                      },
                    },
                    [_vm._v("Aceptar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            scrollable: true,
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.modalPDF,
            callback: function ($$v) {
              _vm.modalPDF = $$v
            },
            expression: "modalPDF",
          },
        },
        [
          _c("render-pdf", {
            attrs: {
              basicRender: true,
              documentType: _vm._f("nameDocumentsType")(
                (_vm.instance || {}).type || ""
              ),
              number: _vm.instance.number,
              loaderRender: _vm.loaderRender,
              renderUrl: _vm.renderUrl,
              flat: true,
              formatPDF: _vm.formatPDF,
              showFormat: true,
            },
            on: {
              close: function ($event) {
                _vm.modalPDF = false
              },
              "update:formatPDF": function ($event) {
                _vm.formatPDF = $event
              },
              "update:format-p-d-f": function ($event) {
                _vm.formatPDF = $event
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            scrollable: true,
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.modalEmail,
            callback: function ($$v) {
              _vm.modalEmail = $$v
            },
            expression: "modalEmail",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { "min-height": "300px" } },
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Enviar documento por email")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.modalEmail = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pa-0 pb-8" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "transparent rounded-0 pa-0",
                          attrs: { flat: "" },
                        },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "background pt-5 pb-3 px-5" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey-500--text body-1",
                                      staticStyle: { "min-width": "60px" },
                                    },
                                    [_vm._v("Para")]
                                  ),
                                  _c("v-combobox", {
                                    staticClass: "a-combobox",
                                    attrs: {
                                      error: _vm.$v.messages.recipient.$error,
                                      "hide-details": "",
                                      items: [],
                                      outlined: "",
                                      required: "",
                                      "hide-selected": "",
                                      placeholder: !_vm.messages.recipient
                                        ? "Escribe el email del destinatario"
                                        : "",
                                      multiple: "",
                                      "hide-no-data": "",
                                      "deletable-chips": "",
                                      "small-chips": "",
                                      "single-line": "",
                                      dense: "",
                                      autocomplete: "off",
                                    },
                                    on: { change: _vm.setEmails },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "v-chip",
                                              _vm._b(
                                                {
                                                  staticClass: "pr-2 ma-1",
                                                  attrs: {
                                                    small: "",
                                                    "input-value":
                                                      data.selected,
                                                    close: "",
                                                  },
                                                  on: {
                                                    click: data.select,
                                                    "click:close": function (
                                                      $event
                                                    ) {
                                                      return _vm.remove(
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-chip",
                                                data.attrs,
                                                false
                                              ),
                                              [_vm._v(_vm._s(data.item))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.$v.messages.recipient.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.messages.recipient,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "$v.messages.recipient.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex align-center mt-3" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey-500--text body-1",
                                      staticStyle: { "min-width": "60px" },
                                    },
                                    [_vm._v("Asunto")]
                                  ),
                                  _c("v-text-field", {
                                    attrs: {
                                      error: _vm.$v.messages.subject.$error,
                                      outlined: "",
                                      required: "",
                                      "single-line": "",
                                      dense: "",
                                      maxlength: "60",
                                      hint: "Escribe un asunto para el mensaje",
                                      "persistent-hint": "",
                                      "hide-details":
                                        !_vm.$v.messages.subject.$error,
                                    },
                                    model: {
                                      value: _vm.$v.messages.subject.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.messages.subject,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.messages.subject.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pa-0 mt-2" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey-500--text body-1 mr-5",
                                    },
                                    [_vm._v("Archivos adjuntos")]
                                  ),
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 pl-1 pr-2",
                                      attrs: {
                                        color: "grey-700",
                                        small: "",
                                        outlined: "",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "ma-0 pb-1",
                                        attrs: {
                                          value: "pdf",
                                          color: "grey-900",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.messages.type,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.messages, "type", $$v)
                                          },
                                          expression: "messages.type",
                                        },
                                      }),
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", size: "14" } },
                                        [_vm._v("mdi-paperclip")]
                                      ),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state?.auth?.account
                                            ?.country === "PE"
                                            ? _vm.instance.number?.replace(
                                                /[ ]/g,
                                                ""
                                              )
                                            : _vm.instance.number
                                        ) + ".pdf "
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 pl-1 pr-2",
                                      attrs: {
                                        color: "grey-700",
                                        small: "",
                                        outlined: "",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "ma-0 pb-1",
                                        attrs: {
                                          value: "xml",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.messages.type,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.messages, "type", $$v)
                                          },
                                          expression: "messages.type",
                                        },
                                      }),
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", size: "14" } },
                                        [_vm._v("mdi-paperclip")]
                                      ),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state?.auth?.account
                                            ?.country === "PE"
                                            ? _vm.instance.number?.replace(
                                                /[ ]/g,
                                                ""
                                              )
                                            : _vm.instance.number
                                        ) + ".xml "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-text",
                            {
                              staticClass:
                                "px-0 mt-2 mx-auto bgPanel text-center",
                              staticStyle: { "max-height": "450px" },
                            },
                            [
                              _c("v-alert", {
                                staticClass: "pa-0 mx-auto",
                                style: `width: ${
                                  _vm.$vuetify.breakpoint.width < 1270
                                    ? 465
                                    : 564
                                }px;`,
                                attrs: {
                                  border: "top",
                                  color: "var(--light-blue-500)",
                                  "colored-border": "",
                                  elevation: "0",
                                },
                              }),
                              _c(
                                "v-sheet",
                                {
                                  staticClass: "mx-auto",
                                  staticStyle: {
                                    "border-radius": "10px",
                                    "margin-top": "-17px",
                                  },
                                  attrs: {
                                    width:
                                      _vm.$vuetify.breakpoint.width < 1270
                                        ? 470
                                        : 570,
                                    outlined: "",
                                  },
                                },
                                [
                                  _c("reminder-documents-email", {
                                    attrs: {
                                      instance: _vm.instance,
                                      activeDocument: _vm.activeDocument,
                                      "color-background":
                                        _vm.account.color_background,
                                      message: _vm.messages.text,
                                    },
                                    on: {
                                      "update:message": function ($event) {
                                        return _vm.$set(
                                          _vm.messages,
                                          "text",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-4 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogMessages = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.$store.state.messages.createLoader,
                        color: "grey-900",
                      },
                      on: { click: _vm.createMessages },
                    },
                    [_vm._v("Enviar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "792",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogReprocessSummarie,
            callback: function ($$v) {
              _vm.dialogReprocessSummarie = $$v
            },
            expression: "dialogReprocessSummarie",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Re-procesar resumen")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogReprocessSummarie = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-4", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-document-null.svg`),
                            width: 148,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "mt-1 mb-3" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "grey-700", size: "14" },
                                },
                                [_vm._v("mdi-file-document")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 font-weight-medium text-uppercase",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.activeDocument?.name ?? "") +
                                      " Nº " +
                                      _vm._s(_vm.instance.type?.slice(2, 4)) +
                                      "-" +
                                      _vm._s(
                                        _vm._f("dateLigth")(_vm.instance.date)
                                      ) +
                                      "-" +
                                      _vm._s(_vm.instance.serial)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "d-block body-1 pt-2" }, [
                            _vm._v(
                              "Al confirmar, se enviará nuevamente este resumen a la SUNAT para su revisión y aceptación. Esta acción no se puede deshacer."
                            ),
                          ]),
                          _c(
                            "span",
                            { staticClass: "d-block body-1 mt-4 mb-3" },
                            [
                              _vm._v("Escribe "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("“confirmar”"),
                              ]),
                              _vm._v(" para continuar."),
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogReprocessSummarie = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.loadingReprocessSummarie,
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.reprocessSummarie },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }